/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Router
import router from './routes';
import store from './store';

window.router = router;

const app = new Vue({
    el: '#app',
    store,
    router,
    beforeCreate() {
        this.$store.commit('cart/initialiseStore');
    },
}).$mount('#app');

import Popover from 'bootstrap/js/src/popover'

window.addEventListener('click', (event) => {
    if(!event.target.classList.contains('popover-header') && !event.target.classList.contains('popover-body') && !event.target.hasAttribute('aria-describedby')) {
        document.querySelectorAll('[data-bs-toggle="popover"][aria-describedby]').forEach((element) => {
            Popover.getInstance(element).hide();
        });
    }
});
